/**
 * Landscape shared block scripts
 * This file gets shared between the
 * theme and editor.
 */
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';


gsap.registerPlugin(ScrollTrigger);

gsap.utils.toArray('.landscape').forEach((landscape) => {

	const lunar = landscape.querySelector('.landscape__feature--lunar');
	const tall = landscape.querySelector('.landscape__feature--tall');
	const mid = landscape.querySelector('.landscape__feature--mid');
	const low = landscape.querySelector('.landscape__feature--low');

	const reverse = landscape.classList.contains('landscape--ani-reverse');

	const applyAni = () => {
		[lunar, tall, mid, low].forEach((el, i) => {
			if (reverse) {
				gsap
				.to(el, {
					y: 0,
					scaleY: 1,
					duration: 1 + ((i+1) * (i*0.15)),
					ease: 'power4.out',
				});
				setTimeout(() => { // works so well with onComplete... except firing is staggered
					gsap.to(el, {
						y: (el !== low && el !== lunar ? `${(i+1)*10}%` : 0),
						x: (el === lunar ? '-1.5em' : 0),
						scaleY: (el === low ? 0 : 1),
						scrollTrigger: {
							trigger: landscape,
							ease: 'linear',
							start: '0 0',
							end: 'bottom top',
							scrub: 1.5,
							toggleActions: 'play reset play reset',
							// /*DEBUG*/markers: true, id: 'landscape-reverse',
						}
					});
				}, 1000);
			} else {
				gsap.to(el, {
					y: 0,
					x: (el === lunar ? '-1.5em' : 0),
					scaleY: 1,
					scrollTrigger: {
						trigger: tall,
						ease: 'linear',
						start: 'top 90%',
						end: 'bottom 75%',
						scrub: 1.5,
						toggleActions: 'play reset play reset',
						// /*DEBUG*/markers: true, id: 'landscape',
					}
				});
			}
		})
	};

	applyAni();

	// force repaint to fix safari bug with blur hard edges
	landscape.querySelectorAll('[class*="--aerial"').forEach((el)=>{
		el.style.display = 'none';
		el.style.opacity = 0;
		setTimeout(() => {
			el.style.display='block';
		}, 300);
		setTimeout(() => {
			el.style.display='block';
			el.style.opacity = 1;
		}, 310);
	});

});